// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import textMasks from "@mcmc/App/Libraries/react-text-mask";
import { FormField, FormState, ValidatorName } from "@mcmc/Overrides/Widgets/CreateAccount/CreateAccount.form-helper";

const requiredValidators: ValidatorName[] = ["required"];
const postalCodeValidators: ValidatorName[] = ["required", "zipCode"];
const emailValidators: ValidatorName[] = ["required", "email"];
const phoneValidators: ValidatorName[] = ["phone"];

export interface EmailUsFormState extends FormState {
    fields: {
        firstName: FormField<string>;
        lastName: FormField<string>;
        emailAddress: FormField<string>;
        companyZipCode: FormField<string>;
        companyName: FormField<string>;
        closetBranch: FormField<string>;
        whatCanWeHelpYouWith: FormField<string>;
        phoneNumber: FormField<string>;
        additionalComments: FormField<string>;
        
    };
}

export const initailEmailUsFormState: EmailUsFormState = {
    isValid: false,
    isSubmitted: false,
    fields: {
        firstName: {
            value: "",
            validators: requiredValidators,
            attrs: {
                id: "contact_us_firstName",
                label: `${translate("First Name")}:`,
                required: true,
                maxLength: 40,
            },
        },
        lastName: {
            value: "",
            validators: requiredValidators,
            attrs: {
                id: "contact_us_lastName",
                label: `${translate("Last Name")}:`,
                required: true,
                maxLength: 40,
            },
        },
        emailAddress: {
            value: "",
            validators: emailValidators,
            attrs: {
                id: "contact_us_mail",
                label: `${translate("Email Address")}:`,
                maxLength: 100,
                required: true,
            },
        },
        companyZipCode: {
            value: "",
            validators: postalCodeValidators,
            attrs: {
                id: "contact_us_zipCode",
                label: `${translate("Zip Code")}:`,
                required: true,
            },
        },
        companyName: {
            value: "",
            validators: requiredValidators,
            attrs: {
                id: "contact_us_companyName",
                label: `${translate("Company")}:`,
                required: true,
            },
        },
        closetBranch: {
            value: "",
            validators: requiredValidators,
            attrs: {
                id: "contact_us_branch",
                label: `${translate("What is your closest branch?")}:`,
                required: true,
            },
        },
        whatCanWeHelpYouWith: {
            value: "",
            validators: requiredValidators,
            attrs: {
                id: "contact_us_request",
                label: `${translate("What can we help you with?")}:`,
                required: true,
            },
        },
        phoneNumber: {
            value: "",
            validators: phoneValidators,
            mask: textMasks.phone,
            attrs: {
                id: "contact_us_phone",
                label: `${translate("Phone Number")}:`,
            },
        },
        additionalComments: {
            value: "",
            validators: requiredValidators,
            attrs: {
                id: "contact_us_comments",
                label: `${translate("Comments")}:`,
                required: true,
            },
        },
    }
};
